"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MockDog = void 0;
var MockDog = exports.MockDog = {
  'petName': 'Fred',
  'petDOB': '2020-01-01',
  'desexed': 1,
  'gender': 'Male',
  'genderId': 2,
  'petNumber': 0,
  'breed': 'Border Collie',
  'breedCode': 'BR0060',
  'species': 'Dog',
  'isCrossBreed': false,
  'speciesCode': 'CANINE'
};